<template>
  <div id="feed-select">
    <button
      v-bind:class="'w3-button w3-theme-l1 w3-left-align' + (feedType==='statement-feed'?' w3-theme-d1':'')"
      @click="viewStatements()"
    ><font-awesome-icon :icon="['fal', 'comment-alt-check']" /> Statements</button>

    <button
      v-bind:class="'w3-button w3-theme-l1 w3-left-align' + (feedType==='convo-feed'?' w3-theme-d1':'')"
      @click="viewConvos()"
    ><font-awesome-icon :icon="['fal', 'comments']" /> Conversations</button>
  </div>
</template>

<script>
  import FeedSelect from './FeedSelect.ts'
  export default FeedSelect
</script>
